import { InjectionToken } from '@angular/core';
import { MenuItem } from '../domain/menuItem.model';

export const MENU_ITEMS = new InjectionToken<MenuItem[]>('MENU_ITEMS', {
  factory: () => [],
});
